// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4211ec18","447":"fcfef3be","453":"bd659253","455":"6c477802","967":"02c5f8bb","977":"f78b6184"}[chunkId] + ".chunk.js";
};